import React, { Component } from "react";
import Error504 from "../error504";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Error504 />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
